import Btn from "../../../components/btn/Btn";
import "./OurImpact.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { images } from "../../../utils/images";
import { Fragment, useRef } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../utils/apiData";
import { paths } from "../../../utils/paths";

const OurImpact = ({ pageData }) => {
  const navigate = useNavigate();

  const swiperRef = useRef(null);
  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };
  return (
    <section className="our_impact p_t">
      <div className="content_wrap">
        <div className="bi_grid">
          <Swiper
            spaceBetween={16}
            slidesPerView={2}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            breakpoints={{
              500: {
                slidesPerView: 2,
              },

              10: {
                slidesPerView: 1,
              },
            }}
          >
            <div className="btn_floats">
              <button type="button" className="l" onClick={handlePrev}>
                <BsArrowLeft />
              </button>
              <button type="button" className="r" onClick={handleNext}>
                <BsArrowRight />
              </button>
            </div>
            {pageData?.impact_image?.map((data, k) => {
              return (
                <SwiperSlide key={k}>
                  <div className="impact_img">
                    <img src={`${baseUrl}/${data}`} alt="Impact" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <div className="right">
            <motion.p
              initial={{ translateX: 32, opacity: 0 }}
              whileInView={{ translateX: 0, opacity: 1 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="tag_title"
            >
              <span>_</span>
              {pageData?.impact_title}
            </motion.p>
            <div
              className="impact_info"
              dangerouslySetInnerHTML={{ __html: pageData?.impact_description }}
            />

            <Btn title="Know More" onClick={() => navigate(paths.ABOUT)} />
          </div>
        </div>
      </div>
    </section>
  );
};
export default OurImpact;
